export default {
  name: "Filter",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M9 15a5.02 5.02 0 0 0 4.9-4H27c.55 0 1-.45 1-1s-.45-1-1-1H13.9A5 5 0 1 0 9 15zm0-8c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zm14 10a5.02 5.02 0 0 0-4.9 4H5c-.55 0-1 .45-1 1s.45 1 1 1h13.1a5 5 0 1 0 4.9-6zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z",
  },
}
